export default "__VITE_ASSET__CyBHa0ku__"